{
  "8174f49c-e3af-43de-bca0-ef6a440c923e": {
    "1000": "An unknown error occurred, try again or contact support"
  },
  "9337844a-5b6f-4b1f-a5dc-552926bdaf19": {
    "1000": "A maximum of 8 fields is allowed",
    "1001": "A maximum of 120 teams is allowed",
    "1002": "At least 2 teams are required"
  }
}
